/**
 * Ticket 도메인 Query Hook Wrapper
 *
 * Adapter를 사용하여 티켓 관련 데이터를 조회합니다.
 */

import {useInfiniteQuery, useQuery} from '@tanstack/react-query';
import {TICKET_QUERY_KEY_MAP} from '../api/ticket/constant';
import {ticketFactory} from '../factory/ticketFactory';

// ============================================
// useContentBuyTicketPageQuery
// ============================================

export function useContentBuyTicketPageQuery(
  ...args: Parameters<typeof ticketFactory.contentBuyTicketPage>
) {
  return useQuery(ticketFactory.contentBuyTicketPage(...args));
}

useContentBuyTicketPageQuery.getKey = (
  ...args: Parameters<typeof TICKET_QUERY_KEY_MAP.contentBuyTicketPage>
) => [...TICKET_QUERY_KEY_MAP.contentBuyTicketPage(...args)];

// ============================================
// useContentCheckFreeTicketQuery
// ============================================

export function useContentCheckFreeTicketQuery(
  ...args: Parameters<typeof ticketFactory.contentCheckFreeTicket>
) {
  return useQuery(ticketFactory.contentCheckFreeTicket(...args));
}

useContentCheckFreeTicketQuery.getKey = (
  ...args: Parameters<typeof TICKET_QUERY_KEY_MAP.contentCheckFreeTicket>
) => [...TICKET_QUERY_KEY_MAP.contentCheckFreeTicket(...args)];

// ============================================
// useContentMyTicketQuery (패턴 2: refetch가 있는 Query)
// ============================================

export function useContentMyTicketQuery(
  ...args: Parameters<typeof ticketFactory.contentMyTicket>
) {
  return useQuery(ticketFactory.contentMyTicket(...args));
}

useContentMyTicketQuery.getKey = (
  ...args: Parameters<typeof TICKET_QUERY_KEY_MAP.contentMyTicket>
) => [...TICKET_QUERY_KEY_MAP.contentMyTicket(...args)];

// ============================================
// useInfiniteContentTicketHistoryBuyQuery
// ============================================

export function useInfiniteContentTicketHistoryBuyQuery(
  ...args: Parameters<typeof ticketFactory.infiniteContentTicketHistoryBuy>
) {
  return useInfiniteQuery(
    ticketFactory.infiniteContentTicketHistoryBuy(...args)
  );
}

useInfiniteContentTicketHistoryBuyQuery.getKey = (
  ...args: Parameters<
    typeof TICKET_QUERY_KEY_MAP.infiniteContentTicketHistoryBuy
  >
) => [...TICKET_QUERY_KEY_MAP.infiniteContentTicketHistoryBuy(...args)];

// ============================================
// useContentTicketHistoryBuyDetailQuery
// ============================================

export function useContentTicketHistoryBuyDetailQuery(
  ...args: Parameters<typeof ticketFactory.contentTicketHistoryBuyDetail>
) {
  return useQuery(ticketFactory.contentTicketHistoryBuyDetail(...args));
}

useContentTicketHistoryBuyDetailQuery.getKey = (
  ...args: Parameters<typeof TICKET_QUERY_KEY_MAP.contentTicketHistoryBuyDetail>
) => [...TICKET_QUERY_KEY_MAP.contentTicketHistoryBuyDetail(...args)];

// ============================================
// useReadyToUseTicketQuery
// ============================================

export function useReadyToUseTicketQuery(
  ...args: Parameters<typeof ticketFactory.readyToUseTicket>
) {
  return useQuery(ticketFactory.readyToUseTicket(...args));
}

useReadyToUseTicketQuery.getKey = (
  ...args: Parameters<typeof TICKET_QUERY_KEY_MAP.readyToUseTicket>
) => [...TICKET_QUERY_KEY_MAP.readyToUseTicket(...args)];

// ============================================
// useSetReadyToUseTicketQuery
// ============================================

export function useSetReadyToUseTicketQuery(
  ...args: Parameters<typeof ticketFactory.setReadyToUseTicket>
) {
  return useQuery(ticketFactory.setReadyToUseTicket(...args));
}

useSetReadyToUseTicketQuery.getKey = (
  ...args: Parameters<typeof TICKET_QUERY_KEY_MAP.setReadyToUseTicket>
) => [...TICKET_QUERY_KEY_MAP.setReadyToUseTicket(...args)];
